import React from "react";
import {
  Dialog,
  Grid,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Stack,
  Chip,
  Card,
  CardHeader,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Close } from "@mui/icons-material";
import FaceIcon from "@mui/icons-material/Face";
import contributors from "../../core/assets/dataContributors";
const StyledChip = styled(Chip)({
  margin: "0.2rem",
});

const ContributorsDialog = () => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledChip
        size=""
        label="ANS Members"
        component="a"
        target="_blank"
        onClick={() => {
          setOpen(true);
        }}
        icon={<FaceIcon />}
      />
      <Dialog
        onClose={handleClose}
        open={open}
        scroll="paper"
        fullScreen
        sx={{ maxWidth: "90vw", margin: "0 auto" }}
      >
        <DialogTitle>
          <Stack spacing={1} direction="row" width="100%">
            <FaceIcon />
            <Typography width="100%" variant="h6" fontWeight="bold">
              ANS Members
            </Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers={true}>
          <Grid container spacing={2}>
            {contributors.map((person) => {
              return (
                <Grid item xs={12} md={4} key={person.name}>
                  <Card key={person.name}>
                    <CardHeader
                      key={person.name}
                      title={person.name}
                      titleTypographyProps={{ fontSize: "1rem" }}
                      subheader={person.organization}
                      subheaderTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ContributorsDialog;
